// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2869":"css/admin-app.7045","7924":"css/app.7045"}[chunkId] + ".css";
};